import * as React from 'react';

interface ProductTooltipProps {
  amount: number;
}

interface ProductTooltipState {
  animate: boolean;
}

class ProductTooltip extends React.Component<ProductTooltipProps, ProductTooltipState>  {
  constructor(props: ProductTooltipProps) {
    super(props);
    this.state = { animate: false };
  }

  componentDidMount() {
    setTimeout(
      () => { this.setState({ animate: true }); },
      10
    );
  }

  render() {
    const { amount } = this.props;
    return (
      <div className={this.state.animate ? 'product__tooltip animate' : 'product__tooltip'}>
        <span>{'+ ' + amount}</span>
      </div>
    );
  }
}

export default ProductTooltip;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProductTooltip.tsx